if($('.type-posts-listing').length){
    $('.news-item').each(function(){
        $(this).find('.description').after('<div class="text-right"><a href="'+$(this).find('.title').attr('href')+'">Číst více</a></div>')
    })
}